import React, { useState, useEffect } from "react"
import withStyles from "react-jss"
import fonts from "./assets/fonts"
import globalStyles, {
  HEADER_FADEOUT,
  QUIZ_FADEOUT,
  RESULTS_FADEOUT,
} from "./data/globalStyles"
// import { rawData } from "./data/rawData"
// import { formatFinalData } from "./utils/helper"
import { Header, Quiz, Results } from "./layouts"
// import { RESULT_IDS } from "./data/uniqueValues"
// import { getImagesFromResultIds } from "./utils/helper"
// import { preloadImages } from "./utils/preloadImages"

const styles = {
  ...fonts,
  ...globalStyles,
  app: {
    // height: "100vh",
  },
}

const App = ({ classes }) => {
  const [show, setShow] = useState({
    intro: true,
    quiz: false,
    results: false,
  })
  // intro || quiz || results
  const [section, setSection] = useState("intro")
  const [giftFor, setGiftFor] = useState("")

  const goToQuiz = ({ animationName }) => {
    if (animationName.includes(HEADER_FADEOUT) && startWithResults) {
      setSection("results")
    } else if (animationName.includes(HEADER_FADEOUT)) {
      setSection("quiz")
    }
  }

  const goToResults = ({ animationName }) => {
    if (animationName.includes(QUIZ_FADEOUT)) {
      setSection("results")
    }
  }

  const goBackToHeader = ({ animationName }) => {
    if (animationName.includes(RESULTS_FADEOUT)) {
      setSection("intro")
    }
  }

  // useEffect(() => {
  //   const test = formatFinalData(rawData)
  //   console.log(test)
  // }, [])

  const [customizedMenu, setCustomizedMenu] = useState([])
  const [resetQuiz, setResetQuiz] = useState(false)
  const [startWithResults, setStartWithResults] = useState(false)

  return (
    <div className={classes.app}>
      <Header
        show={show.intro}
        setShow={setShow}
        section={section}
        onAnimationEnd={goToQuiz}
        startWithResults={startWithResults}
      />
      <Quiz
        show={show.quiz}
        setShow={setShow}
        section={section}
        onAnimationEnd={goToResults}
        setCustomizedMenu={setCustomizedMenu}
        resetQuiz={resetQuiz}
        setGiftFor={setGiftFor}
        setResetQuiz={setResetQuiz}
      />
      <Results
        show={show.results}
        setShow={setShow}
        section={section}
        onAnimationEnd={goBackToHeader}
        ids={customizedMenu}
        setResetQuiz={setResetQuiz}
        startWithResults={startWithResults}
        giftFor={giftFor}
      />
    </div>
  )
}

export default withStyles(styles)(App)
